import { useSelector } from "react-redux";
import { Layout } from "antd";
import EmployeePositionAdminPage from "../../pages/EmployeePositionAdmin/EmployeePositionAdminPage";
import SuperAdminPage from "../../pages/SuperAdmin/SuperAdminPage";
import EBulletinPage from "../../pages/EBulletinAdmin/EBulletinPage";
// import DashboardPage from "../../pages/Dashboard/DashboardPage";
import ApproverPage from "../../pages/Approver/ApproverPage";
import SpectatorPage from "../../pages/Spectator/SpectatorPage";
import NotFoundPage from "../../pages/Error/NotFoundPage";
import CybersecurityPage from "../../pages/Cybersecurity/CybersecurityPage";
import PhishingLeaderBoardPage from "../../pages/PhishingLeaderboard/PhishingLeaderboardPage";
import BulletinPage from "../../pages/Bulletin/BulletinPage";
import DocumentRequestPage from "../../pages/DocumentRequest/DocumentRequestPage";
import FacultyProfilePage from "../../pages/FacultyProfile/FacultyProfilePage";
import PivotLoading from "../Loading/PivotLoading";
import HomePage from "../../pages/Home/HomePage";
import UserCalendarOverviewPage from "../../pages/Ouber/user/UserCalendarOverviewPage";
import OuberAdminPage from "../../pages/Ouber/OuberAdminPage";
import FsrAdminPage from "../../pages/FsrAdmin/FsrAdminPage";
import PrismPage from "../../pages/Prism/PrismPage";

import NavigationDrawer from "./NavigationDrawer";
import PivotHeader from "./PivotHeader";

const { Header, Content, Footer } = Layout;

const AppLayout = () => {
  const { currentPage, loginLoaded } = useSelector(
    (state) => state.generalSlice
  );
  const { details = {} } = useSelector((state) => state.accountDetailSlice);
  const isEmployeeInactive = details?.is_active === false;

  const renderContent = () => {
    if (isEmployeeInactive) {
      return <HomePage />;
    }

    switch (currentPage) {
      case "dashboard":
        return <HomePage />;
      case "faculty-profile":
        return <FacultyProfilePage />;
      case "doc-req":
        return <DocumentRequestPage />;
      case "spectator":
        return <SpectatorPage />;
      case "approver":
        return <ApproverPage />;
      case "positionsAdmin":
        return <EmployeePositionAdminPage />;
      case "superAdmin":
        return <SuperAdminPage />;
      case "cybersecurity":
        return <CybersecurityPage />;
      case "phishing-leaderboard":
        return <PhishingLeaderBoardPage />;
      case "bulletin":
        return <BulletinPage />;
      case "ebulAdmin":
        // Render the eBulletin page in admin mode
        return <EBulletinPage isAdmin={true} />;
      case "ebulletin":
        // Render the eBulletin page in view-only (non-admin) mode
        return <EBulletinPage isAdmin={false} />;
      case "fsrAdmin":
        return <FsrAdminPage />;
      case "ouber-user-calendar":
        return <UserCalendarOverviewPage />;
      case "ouber-admin":
        return <OuberAdminPage />;
      case "prism":
        return <PrismPage />;
      default:
        return <NotFoundPage />;
    }
  };

  return loginLoaded ? (
    <Layout className="pivot">
      <NavigationDrawer />
      <Layout className="pivot-body">
        <Header className="pivot-header">
          <PivotHeader />
        </Header>
        <Content className="pivot-content">{renderContent()}</Content>
        <Footer className="pivot-footer">
          © Developed by the UPOU ICT Development Office. All rights reserved {new Date().getFullYear()}.
        </Footer>
      </Layout>
    </Layout>
  ) : (
    <PivotLoading />
  );
};

export default AppLayout;
